var request_domain = (process.env.NODE_ENV === 'production' && location.host.indexOf('pcchain.wxpass.net') == -1) ? location.host : "xchain.wxtome.link"
let config = {
    BASEURL: `${location.protocol == 'http:' ? 'http' : 'https'}://api.${request_domain}`,
}
if (process.env.NODE_ENV == 'development') {
    config = {
        BASEURL: 'https://api.tldrus.com'
    }
}
export default config;